(function ($, undefined) {
  /*============================================
   Header thin on scroll
  ==============================================*/
  $(function () {
    const $document = $(document),
      $header = $(".header"),
      HEADER_TOP_OFFSET = window.innerWidth > 992 ? 50 : 20;

    const toggleHeaderClasses = () => {
      if ($document.scrollTop() > HEADER_TOP_OFFSET) {
        $header.addClass("header_scroll");
      } else {
        $header.removeClass("header_scroll");
      }
    }

    $document.scroll(toggleHeaderClasses);
    toggleHeaderClasses();
  });

  /*============================================
   Swiper Sliders
  ==============================================*/
  $(function () {
    const $reviewsSwiper = $('.reviews-swiper');

    if ($reviewsSwiper.length) {
      new Swiper($reviewsSwiper[0], {
        slidesPerView: 1,
        spaceBetween: 25,
        autoHeight: true,
        navigation: {
          nextEl: ".reviews-swiper-button-next",
          prevEl: ".reviews-swiper-button-prev",
        },
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            autoHeight: true,
          },
          1200: {
            slidesPerView: 3,
            autoHeight: false
          }
        }
      });
    }
  });
})(jQuery);
